// DO NOT CHANGE THIS FILE MANUALLY.
// It was generated using scripts/lib/template.ts
import * as React from "react";
export const IconAdd = ({
  size,
  onClick,
  ...otherProps
}: React.SVGProps<SVGSVGElement> & {
  /** @deprecated - wrap in a `<DDSButton variant="ghost">` put the onClick on there */ onClick?: never;
  size?: "xs" | "s" | "m" | "l" | "xl" | "xxl";
}) => {
  const props = {
    ...otherProps,
    className: "mdsIcon " + (size || "") + " " + (otherProps.className || ""),
  };
  return (
    <svg {...props} viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
      <path d="M52 30.125V33.875C52 35.1091 51.2341 35.875 50 35.875C48.9821 35.875 43.0768 35.0734 34.907 34.907C35.0734 43.0768 35.875 48.9821 35.875 50C35.875 51.2341 35.1091 52 33.875 52H30.125C28.8909 52 28.125 51.2341 28.125 50C28.125 48.9821 28.9266 43.0768 29.093 34.907C20.9232 35.0734 15.0179 35.875 14 35.875C12.7659 35.875 12 35.1091 12 33.875V30.125C12 28.8909 12.7659 28.125 14 28.125C15.0179 28.125 20.9232 28.9266 29.093 29.093C28.9266 20.9232 28.125 15.0179 28.125 14C28.125 12.7659 28.8909 12 30.125 12H33.875C35.1091 12 35.875 12.7659 35.875 14C35.875 15.0179 35.0734 20.9232 34.907 29.093C43.0768 28.9266 48.9821 28.125 50 28.125C51.2341 28.125 52 28.8909 52 30.125Z" />
    </svg>
  );
};
